import React from 'react';
import "../css/MainInput.css";

const MainInput = ({
  label = "",
  placeholder,
  langDir = "en",
  onChange,
  onBlur,
  value,
  onFocus,
  required = false,
  type = "text",
  forceWidht = false,
  dir = "ltr",
  disabled = false,
  max,
  rows = 4,
  min,
  accept,
  step
}) => {
  return (
    <div className={forceWidht ? "coolinput2" : "coolinput mx-auto"} dir={dir}>
      <label htmlFor="input" className={dir === "ltr" ? "text" : "textAr"}>
        {label}
      </label>

      {type === "textarea" ? (
        <textarea
          disabled={disabled}
          placeholder={placeholder}
          name="input"
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          className={langDir === "en" ? "input" : "input text-end"}
          required={required}
          value={value}
          rows={rows}
        />
      ) : (
        <input
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          name="input"
          onChange={onChange}
          onBlur={onBlur}
          accept={accept}
          step={step}
          onFocus={onFocus}
          className={langDir === "en" ? "input" : "input text-end"}
          required={required}
          value={value}
          max={max}
          min={min}
        />
      )}
    </div>
  );
};

export default MainInput;